import styled from 'styled-components'

export const Right = styled.div`
  margin-left: auto;
`
